/*=========================================================================================
  File Name: moduleAuthState.js
  Description: Auth Module State
  ----------------------------------------------------------------------------------------
  Item Name: Vue Monica Refine Design
  Author: Riyan Kurniawan
  -- MONICA --
==========================================================================================*/

import auth from '@/auth/authService'
import firebase from 'firebase/app'
import 'firebase/auth'

export default {
  isUserLoggedIn: () => {
    let isAuthenticated = false

    // get firebase current user
    const firebaseCurrentUser = firebase.auth().currentUser

    if (auth.isAuthenticated() || firebaseCurrentUser) isAuthenticated = true
    else isAuthenticated = false

    return localStorage.getItem('userInfo') && isAuthenticated
  },
  getUserRole: () => {
    // check if user is logged in
    if (!localStorage.getItem('userInfo')) return null

    return JSON.parse(localStorage.getItem('userRole'))
  },
  getUserPermissions: () => {
    // check if user is logged in
    if (!localStorage.getItem('userInfo')) return null

    return JSON.parse(
      JSON.parse(localStorage.getItem('userRole')).role_permession.permession
    )
  },
}
